// extracted by mini-css-extract-plugin
module.exports = {"b_alphabet":"Alphabet_b_alphabet__7z6q2","b_alphabet_current":"Alphabet_b_alphabet_current__snd0T"};